import { curry } from 'ramda';
import { IAppState } from '../../redux';
import { IRecommendedServicePackage } from '../../redux/reducers';
import { selectServiceById } from './selectServiceById';

export const selectActiveRecommendedPackageByServiceId = curry(
  (serviceId: string, state: IAppState): IRecommendedServicePackage | null => {
    const selectedService = selectServiceById(serviceId, state);

    if (!selectedService) {
      return null;
    }

    const {
      publishOptions: { recommendedPackages, selectedRecommendedPackageId },
    } = selectedService;

    if (!selectedRecommendedPackageId) {
      return null;
    }

    return recommendedPackages[selectedRecommendedPackageId];
  },
);
